import { Modal, Panel } from 'rsuite';
import { type UseCriarMonitoramentoFormInitialValues, useCriarMonitoramentoForm } from '../../hooks/useCriarMonitoramentoForm';
import { WARNING_PRODUTO, WARNING_VAREJO } from '../../monitoringWarningMessages';
import { MonitoramentoDetalheDTO, MonitoramentoTipo } from '../../types';
import { CompartilhamentoForm } from '../CompartilhamentoForm';
import { FiltrosResumo } from '../FiltrosResumo';
import { FormFooter } from '../FormFooter';
import { NomeMonitoramentoForm } from '../NomeMonitoramentoForm';
import { PreferencesForm } from '../PreferencesForm';
import { RegraNotificacaoForm } from '../RegraNotificacaoForm';
import styles from './CriarMonitoramentoModal.module.scss';

type CriarMonitoramentoModalProps = {
  initialValues: UseCriarMonitoramentoFormInitialValues;
  onClose: () => void;
  onCreated: (detalhe: MonitoramentoDetalheDTO) => void;
};

export const CriarMonitoramentoModal = ({ initialValues, onClose, onCreated }: CriarMonitoramentoModalProps) => {
  const {
    nomeMonitoramento,
    setNomeMonitoramento,
    monitoringType,
    detalhamento,
    regraNotificacao,
    setRegraNotificacao,
    priceType,
    setPriceType,
    physicalChannel,
    setPhysicalChannel,
    digitalChannel,
    setDigitalChannel,
    compartilhadoCom,
    setCompartilhadoCom,
    isSubmitting,
    handleSubmit,
  } = useCriarMonitoramentoForm({ initialValues });

  const isProdutoMode = monitoringType === MonitoramentoTipo.COMPETITIVIDADE_PRODUTO;

  const handleSubmitAndClose = async () => {
    const detalhe = await handleSubmit();
    if (detalhe) {
      onCreated(detalhe);
    }
  };

  return (
    <Modal show size="md" onHide={onClose}>
      <Modal.Header onHide={onClose}>
        <Modal.Title className={styles.title}>Monitorar competitividade</Modal.Title>
        <p className={styles.subtitle}>Receba alertas de acordo com as variações de competitividade dos produtos que você selecionar nas redes selecionadas.</p>
      </Modal.Header>
      <Modal.Body className={styles.body}>
        <div className={styles.infoBox}>{isProdutoMode ? WARNING_PRODUTO : WARNING_VAREJO}</div>

        <NomeMonitoramentoForm value={nomeMonitoramento} onChange={setNomeMonitoramento} hideHeader />

        {monitoringType && <FiltrosResumo monitoringType={monitoringType as MonitoramentoTipo} detalhamento={detalhamento} />}

        <RegraNotificacaoForm value={regraNotificacao} onChange={setRegraNotificacao} layout="stacked" />

        <Panel
          className={styles.preferencesPanel}
          header={
            <div className={styles.preferencesPanelHeader}>
              <span className={styles.preferencesPanelTitle}>Preferências</span>
              <span className={styles.preferencesPanelSubtitle}>Revise as preferências previamente selecionadas</span>
            </div>
          }
          collapsible
          defaultExpanded={false}
        >
          <PreferencesForm
            priceType={priceType}
            onChangePriceType={setPriceType}
            physicalChannel={physicalChannel}
            onChangePhysicalChannel={setPhysicalChannel}
            digitalChannel={digitalChannel}
            onChangeDigitalChannel={setDigitalChannel}
            hideHeader
          />
        </Panel>

        <Panel
          className={styles.preferencesPanel}
          header={
            <div className={styles.preferencesPanelHeader}>
              <span className={styles.preferencesPanelTitle}>Compartilhamento (opcional)</span>
              <span className={styles.preferencesPanelSubtitle}>Selecione membros para visualizar o monitoramento. Edição e exclusão não são permitidas.</span>
            </div>
          }
          collapsible
          defaultExpanded
        >
          <CompartilhamentoForm value={compartilhadoCom} onChange={setCompartilhadoCom} hideHeader />
        </Panel>
      </Modal.Body>
      <Modal.Footer>
        <FormFooter onCancel={onClose} onSubmit={handleSubmitAndClose} isSubmitting={isSubmitting} submitLabel="CRIAR MONITORAMENTO" />
      </Modal.Footer>
    </Modal>
  );
};
